"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.imageToText = exports.imageToMjml = void 0;

var _base = require("./common/base");

var _formatDefinition = require("./common/formatDefinition");

var imageToMjml = function imageToMjml(item, blockRenderer, isTopLevelNode) {
  var mjImage = (0, _base.toMjml)('mj-image', item.properties, _formatDefinition.EDIE_PROPS[_formatDefinition.EDIE_BLOCK_TYPE.IMAGE]);

  if (item.properties.condition) {
    var mjText = (0, _base.toMjml)('mj-text', {
      content: item.properties.conditionAlt
    }, _formatDefinition.EDIE_PROPS[_formatDefinition.EDIE_BLOCK_TYPE.TEXT]);
    mjImage = "{{#if ".concat(item.properties.condition, "}}").concat(mjImage, "{{else}}").concat(mjText, "{{/if}}");
  } // mj-image NOT allowed in mj-body, so in case this is what EDIE
  // defines, we need to enclose in section/column


  return isTopLevelNode ? (0, _base.encloseInMjmlSection)(mjImage) : mjImage;
};

exports.imageToMjml = imageToMjml;

var imageToText = function imageToText(item) {
  var alt = "".concat(item.properties.alt || 'Image', "\r\n");
  var href = item.properties.href ? "[".concat(item.properties.href, "]\r\n") : '';
  return "".concat(alt).concat(href);
};

exports.imageToText = imageToText;